export default __webpack_public_path__ + "static/media/payment-terminals.2fd3fc37.svg";